import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { IBaseDto } from '@http/clients/reporting-app/base-dto.service';
import { ReportingOpportunitiesSearchService } from '@http/clients/reporting-app/reporting-opportunities-search.service';
import { ReportsService } from '@services/reports.service';
import { CustomMenuItemComponent } from '@shared/custom-menu-item/custom-menu-item.component';
import { EditorComponentBase, GenericTypeAheadMultiselectComponent } from 'ngx-lib';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-reporting-opportunity-search-editor',
    templateUrl: './reporting-opportunity-search-editor.component.html',
    styleUrls: ['./reporting-opportunity-search-editor.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [GenericTypeAheadMultiselectComponent, CustomMenuItemComponent]
})
export class ReportingOpportunitySearchEditorComponent
    extends EditorComponentBase<number[] | null>
    implements OnInit, OnDestroy
{
    items: IBaseDto[];
    selectedItems?: IBaseDto[];
    subscription?: Subscription;

    constructor(
        private readonly reportingOpportunitySearchService: ReportingOpportunitiesSearchService,
        private readonly reportsService: ReportsService
    ) {
        super();
        this.items = [];
    }

    async ngOnInit(): Promise<void> {
        this.subscription = this.reportsService.selectedProperty$.subscribe(async (ready) => {
            if (ready && this.bindingProperty !== null && this.bindingProperty?.length) {
                this.selectedItems = await this.reportingOpportunitySearchService.getByIds(this.bindingProperty);
            } else if (ready && (this.bindingProperty === null || this.bindingProperty === undefined)) {
                this.selectedItems = [];
            }
        });
    }

    async onSelectedItemsChange(): Promise<void> {
        if (this.selectedItems) {
            this.bindingProperty = this.selectedItems.length ? this.selectedItems.map((item) => item.id) : null;
        }
    }

    async onEntityTextChange(text: string) {
        this.items = await this.reportingOpportunitySearchService.search(text);
    }

    ngOnDestroy(): void {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
}
